<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.invoice"
        :primary-fields="[ 'invoice_date', 'invoice_account_counter' ]"
        :hidden-fields="[ 'account', 'invoice_status' ]"
        @ready="load"
        @apply="reload"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        v-loading="isLoadingInvoices"
        shadow="never"
      >
        <SalesAccountsAccountInvoicesTable :invoices="invoices">
          <template v-slot:actions="{ invoice }">
            <el-dropdown
              split-button
              trigger="click"
              size="small"
            >
              Download

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="!invoice.parent">
                  Download Parent Invoice
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </SalesAccountsAccountInvoicesTable>

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="invoices.page"
          :page-size.sync="invoices.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="invoices.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import SalesAccountsAccountInvoicesTable from '@/components/Application/Sales/Accounts/Account/Invoices/Table'
import Filter, { IS } from '@/plugins/sdk/Filter'

export default {
  components: {
    Filters,
    SalesAccountsAccountInvoicesTable
  },
  data () {
    return {
      breadcrumb: {
        name: 'Invoices',
        route: { name: 'sales-accounts-account-invoices', params: { accountId: this.$route.params.accountId } }
      },
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoadingInvoices: false,
      invoices: [],
      filters: []
    }
  },
  methods: {
    async load () {
      this.isLoadingInvoices = true

      try {
        this.invoices = await this.$sdk.invoice.list(request => {
          request.order = 'invoice_date:desc'
          request.filters = [
            new Filter('account', IS, this.$route.params.accountId),
            ...this.filters
          ]
        })
      } finally {
        this.isLoadingInvoices = false
      }
    },
    async reload () {
      this.isLoadingInvoices = true

      try {
        await this.invoices.reload(request => {
          request.filters = [
            new Filter('account', IS, this.$route.params.accountId),
            ...this.filters
          ]
        })
      } finally {
        this.isLoadingInvoices = false
      }
    }
  }
}
</script>
